import { useState, useEffect } from "react"
import type { StatsData } from "./types"
import { getMockStatsData } from "./mockData"
import i18n from "@/lib/i18n/i18n"

interface UseStatsDataOptions {
  dateRange: { from: Date; to: Date } | null
  driverId: string
}

interface UseStatsDataResult {
  data: StatsData | null
  isLoading: boolean
  error: string | null
}

export function useStatsData({
  dateRange,
  driverId,
}: UseStatsDataOptions): UseStatsDataResult {
  const [data, setData] = useState<StatsData | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      setError(null)

      try {
        // Simulate network delay for realistic UX
        await new Promise((resolve) => setTimeout(resolve, 500))

        // Currently uses mock data
        // TODO: Replace with AdHocCommands.getStats() when API is ready
        const mockData = getMockStatsData({ dateRange, driverId })
        setData(mockData)
      } catch (err) {
        setError(
          err instanceof Error
            ? err.message
            : i18n.t("planner.stats.fetchFailed"),
        )
      } finally {
        setIsLoading(false)
      }
    }

    fetchData()
  }, [dateRange, driverId])

  return { data, isLoading, error }
}
